import advance from 'locales/dental/en/finance/advance.json'
import incomeExpenses from 'locales/dental/en/finance/income-expenses.json'
import overdue from 'locales/dental/en/finance/overdue.json'
import paymentQueue from 'locales/dental/en/finance/payment-queue.json'
import payment from 'locales/dental/en/finance/payment.json'
import salary from 'locales/dental/en/finance/salary.json'
import installment from 'locales/dental/en/finance/installment.json'

export const PaymentEN = {
  ...advance,
  ...incomeExpenses,
  ...overdue,
  ...paymentQueue,
  ...payment,
  ...salary,
  ...installment
}
